import React from 'react'
import styles from './PatientReport.css'
import ReportFile from '../../containers/ReportFile'

class PatientReport extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      match,
      setInitialPatientReportData,
    } = this.props
    setInitialPatientReportData(match)
  }

  render() {
    const {
      handleOnPatientBackClick,
      getPatientReportData,
      selectedPatientId,
    } = this.props

    return (
      <div data-page="patient-report" className={styles.patientReport}>
        <ReportFile
          getPrerequisiteData={getPatientReportData}
          handleOnAllReportsRedirect={() => handleOnPatientBackClick(true, true, { patientId: selectedPatientId })}
          showViewPatientOption={false}
        />
      </div>
    )
  }
}

export default PatientReport



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientReport/PatientReport.jsx